<template>
  <div v-loading="loading" class="GmzAndYszxx">
    <div class="_title">
      <p class="_title_info">核查购买证</p>
    </div>
    <div>
      <el-form
        ref="searchForm"
        label-position="right"
        label-width="200px"
        class="formClass"
      >
        <el-form-item label="购买证编号：" prop="xkzBh">
          <el-input v-model="xkzBh" />
        </el-form-item>
      </el-form>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="searchSubmit"> 搜 索 </el-button>
      </div>
    </div>
    <div v-if="!dataExist" style="height: 470px">
      <div style="text-align: center;margin-top: 150px;margin-bottom: 100px;color: #27660dbf;font-size: 30px;">请输入要核查的购买证编号</div>
    </div>
    <div v-else >
      <div style="width: 55%;float: left;overflow-y: auto;height: 615px;">
        <el-image
          style="width: 100%"
          :src="getPicUrl(gmzPic)"></el-image>
      </div>
      <div style="width: 43%;float: right;">
        <h3>核查购买证</h3>
        <el-form ref="saveForm" :model="form" label-width="100px" :rules="rules">
          <el-form-item label="许可证编号:">
            <el-input disabled :value="xkzBh"  style="width: 407px"/>
          </el-form-item>
          <el-form-item label="核查日期:" prop="hcDate">
            <el-date-picker
              v-model="form.hcDate"
              type="date"
              style="width: 407px"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerBeginDateBefore"
            />
          </el-form-item>
          <el-form-item label="核查人:" prop="hcUserId">
            <!--新增和编辑时，需要可切换选择-->
            <el-select
              v-model="form.hcUserId"
              filterable
              placeholder="请选择"
              style="width: 407px"
            >
              <el-option
                v-for="item in xsdwCyryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="核查结果:"
                        prop="hczt">
            <el-radio v-model="form.hczt" label="11">通过</el-radio>
            <el-radio v-model="form.hczt" label="22">不通过</el-radio>
          </el-form-item>
            <el-form-item
              label="不通过理由:"
              prop="bgly"
            >
              <el-input
                :disabled = '!btgYyShow'
                v-model="form.hcsm"
                type="textarea"
                :rows="3"
                resize="none"
                style="width: 407px"
                placeholder="核查不通过时必填"
              />
            </el-form-item>
        </el-form>
        <div style="margin-left: 30%;margin-top: 45px;">
          <el-button
            type="primary"
            style="margin-bottom: 17px;width: 200px;"
            @click="submitForm"
          >保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getHcGmzxxByXkzBh, saveGmzHcxx} from "@/assets/js/system";
import {isEmpty} from "@/utils/tool";
import {addoreditscrkMes, returnShowPic} from "@/assets/js/common";
export default {
  name: 'GmzAndYszxx',
  data() {
    return {
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      loading: false,
      dataExist: false,
      xkzBh:'',
      gmzPic: '',
      xsdwCyryList:[],
      nowGmzId: '',
      btgYyShow:false,
      form:{
        gmzId:'',
        xkzBh:'',
        hczt:'',
        hcsm:'',
        hcUserId:'',
        hcDate:''
      },
      rules: {
        hcDate: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        hcUserId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        hczt: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ]
      },
    }
  },
  watch: {
    'form.hczt': {
      handler(newVal, oldVal) {
        if(newVal == '22'){
          this.btgYyShow = true
        }else{
          this.btgYyShow = false
        }
      },
      deep: true
    }
  },
  mounted(){
  },
  methods: {
    getPicUrl(picUrl){
      if(picUrl == 'none_data.jpg'){
        return require('@/assets/img/none_data.jpg')
      }else{
        return returnShowPic()+picUrl
      }
    },
    submitForm(){
      this.$refs['saveForm'].validate((valid, obj) => {
        if (valid) {
          this.$confirm('此操作将进行核查，不可撤回, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.form.gmzId = this.nowGmzId
            this.loading = true
            saveGmzHcxx(this.form).then((e) => {
              this.loading = false
              this.$message.success('保存成功!')
              this.reset()
            }).catch((error) => {
              this.loading = false
            })
          })
        } else {
          return false
        }
      })
    },
    reset(){
      this.xkzBh = ''
      this.dataExist = false
      this.cshYwsj()
    },
    searchSubmit(){
      this.loading = true
      this.cshYwsj()
      if(!isEmpty(this.xkzBh)){
        getHcGmzxxByXkzBh({xkzBh: this.xkzBh}).then((e) => {
          let res = e.data
          if(res.code == '000000'){
            this.dataExist = true;
            this.nowGmzId = res.data.gmzId
            this.gmzPic = isEmpty(res.data.imgYzUrl)?'none_data.jpg':res.data.imgYzUrl
            this.xsdwCyryList = res.data.cyryList
          }else{
            this.dataExist = false
          }
          this.loading = false
        }).catch((e)=>{
          this.dataExist = false
          this.loading = false
        })
      }else{
        this.$message.warning("请输入购买证编号")
        this.loading = false
      }
    },
    cshYwsj(){ //数据初始化
      this.gmzPic = 'none_data.jpg'
      this.form = this.$options.data().form
      this.xsdwCyryList = []
    },
  }
}
</script>

<style lang='less' scoped>
.GmzAndYszxx {
  overflow-y: auto;
  padding: 20px;
  background-color: white;
  margin: 10px;
  ._title {
    margin-top: 20px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 15px;
      height: 15px;
      font-family: Helvetica;
    }
  }
  .formClass{
    width: 35%;
    margin-right: 20px;
    display: inline-block;
  }
  .buttonList {
    display: inline-block;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 40px auto 0px auto;
    width: 50%;
  }

  .small_img{
    width: 114px;
    height: 114px;
  }

  .date_input{
    width: 31%;
  }

  /deep/ .el-dialog .el-dialog__body {
    height: 650px !important;
    overflow-y: auto !important;
  }
}
</style>
